export enum FinSobSidePanelSettingGroup {
  Planning = 1,
  Mps = 2,
  Mif = 3,
}
